import { defineStore } from "pinia";

export const EMAIL_PREFERENCE_STATUS = Object.freeze({
  SUBSCRIBED: "subscribed",
  UNSUBSCRIBED: "unsubscribed",
  INVALID: "invalid",
});

const SAVE_ERROR = "We couldn't update your email preferences. Please try again.";
const KNOWN_STATUSES = Object.values(EMAIL_PREFERENCE_STATUS);

function preferencesUrl(token, suffix = "") {
  return `${window.blclient.data.links.web}/o/u/${encodeURIComponent(token)}${suffix}`;
}

export const useEmailPreferencesStore = defineStore("email-preferences-store", {
  state: () => ({
    status: "",
    isSaving: false,
    saveError: "",
  }),
  actions: {
    unsubscribe(token) {
      this.post(preferencesUrl(token));
    },
    resubscribe(token) {
      this.post(preferencesUrl(token, "/resubscribe"));
    },
    post(url) {
      this.isSaving = true;
      this.saveError = "";
      this.apiPost(url, {}, data => {
        if (!KNOWN_STATUSES.includes(data?.status)) {
          console.error(`Email preference update to ${url} returned no known status; nothing changed: ${JSON.stringify(data)}`); // eslint-disable-line no-console
          this.saveError = SAVE_ERROR;
          return;
        }
        this.status = data.status;
      }, () => {
        this.saveError = SAVE_ERROR;
      }, () => {
        this.isSaving = false;
      });
    },
  },
});
